import {
    Box,
    Checkbox,
    FormControlLabel,
    IconButton,
    Typography
} from "@mui/material";
import {
    NotificationChannel,
    NotificationRecipient
} from "../../models";

import CloseIcon from '@mui/icons-material/Close';
import React from "react";

type RecipientNotificationSettingProps = {
    index: number;
    recipient: NotificationRecipient;
    recipientName: string;
    disableEmail: boolean;
    disableSMS: boolean;
    toggleNotificationChannel: (recipientId: string, channel: NotificationChannel) => void;
    removeRecipient?: (recipientId: string) => void;
};

export const RecipientNotificationSetting = (props: RecipientNotificationSettingProps) => {
    const { index, recipient, disableEmail, disableSMS, recipientName, toggleNotificationChannel, removeRecipient } = props;
    return (
        <Box
            key={index}
            display="grid"
            gap={1}
            alignItems="center"
            justifyContent="space-between"
            gridTemplateColumns="1fr max-content"
        >
            <Typography>
                {index + 1}. {recipientName}
            </Typography>
            <Box display="flex">
                <FormControlLabel
                    disabled={disableEmail}
                    control={
                        <Checkbox
                            checked={!!recipient.notificationChannels?.includes(NotificationChannel.EMAIL)}
                            onChange={() => toggleNotificationChannel(recipient.recipientId!, NotificationChannel.EMAIL)}
                            name="subscribeEmail"
                            color="success"
                            size="small"
                        />
                    }
                    label="Email"
                    color="success"
                />
                <FormControlLabel
                    disabled={disableSMS}
                    control={
                        <Checkbox
                            checked={!!recipient.notificationChannels?.includes(NotificationChannel.SMS)}
                            onChange={() => toggleNotificationChannel(recipient.recipientId!, NotificationChannel.SMS)}
                            name="subscribeSMS"
                            color="success"
                            size="small"
                        />
                    }
                    label="SMS"
                    color="success"
                />
                {removeRecipient && (
                    <IconButton
                        size="small"
                        onClick={() => removeRecipient(recipient.recipientId!)}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </Box>
        </Box>
    );
};